import { ContentfulPageListing } from '@jbhi-fi/apis/src/contentful/types';

import { ContentfulPagesListProps } from '../../ContentfulPagesList/ContentfulPagesList';

export abstract class PageListingTransformer {
  static toContentfulPagesListProps = ({ fields }: ContentfulPageListing): ContentfulPagesListProps => {
    return {
      pageType: fields?.pageTypeToQuery,
      collectionType: fields?.collectionType,
      order: fields?.sorting === 'Alphabetical (Descending)' ? 'desc' : 'asc',
    };
  };
}
